import DividingHeader from "./DividingHeader";

import "./DividingHeader.scss";

export * from "./DividingHeader.types";

export { DividingHeader };
